import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import TripServices from '../../services/externalServices/tripServices'; // Replace with the path to your service file

// Async thunk for API call
export const fetchTripDetails = createAsyncThunk(
  'trip/fetchTripDetails',
  async (serviceType) => {
    try {
        const response = await TripServices.getTripDetails(serviceType);
        console.log("fetchTripDetails=====================in Redux===========================",response)
        return { data: response, serviceType };
    } catch (error) {
        console.error("error getting the trip data from the redux",error)
    }
   
  }
);



// Create the slice
const tripSlice = createSlice({
  name: 'trip',
  initialState: {
    data: null,
    currentServiceType: null, 
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTripDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTripDetails.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
        state.currentServiceType = action.payload.serviceType;
      })
      .addCase(fetchTripDetails.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      });
  },
});

// Export the reducer to configure the store
export default tripSlice.reducer;
